import { render, staticRenderFns } from "./HandwriteDialog.vue?vue&type=template&id=503feffe&scoped=true&"
import script from "./HandwriteDialog.vue?vue&type=script&lang=js&"
export * from "./HandwriteDialog.vue?vue&type=script&lang=js&"
import style0 from "./HandwriteDialog.vue?vue&type=style&index=0&id=503feffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503feffe",
  null
  
)

component.options.__file = "HandwriteDialog.vue"
export default component.exports